module.exports = "<%= icon %><span class=\"sharecount__value sharecount__value--short\">0</span> Shares\n"